import { render, staticRenderFns } from "./CRImage.vue?vue&type=template&id=7ce94b06&"
import script from "./CRImage.vue?vue&type=script&lang=js&"
export * from "./CRImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports